export default {
  online: {
    no_offer: {
      default: 'Aucune offre disponible avec les critères choisis',
      validation: "En raison de la politique de validation définie par votre société, aucune offre n'est disponible avec les critères choisis."
    },
    filters: {
      travelPolicy: {
        title: 'Politique voyage',
        options: {
          fitsTravelPolicy: 'Sélectionner uniquement des hôtels dans la politique voyage'
        }
      },
      services: {
        title: 'Services',
        options: {
          parking: 'Parking',
          restaurant: 'Restaurant',
          internetAccessinRoom: 'Internet',
          breakfast: 'Petit-déjeuner',
          disabled: 'Accès PMR'
        }
      },
      category: {
        title: "Nombre d'étoiles"
      },
      price: {
        title: 'Prix par chambre par jour'
      },
      hotelType: {
        title: "Type d'hôtel",
        options: {
          wellness: "Bien-être",
          city: "Centre-ville",
          castle: "Château",
          conference: "Séminaire",
          design: "Design",
          family: "Famille",
          golf: "Golf",
          luxury: "Luxueux",
          beach: "Plage",
          hiking: "Randonnée",
          resort: "Resort",
          ski: "Ski"
        }
      },
      topQualityHotel: {
        title: "Hôtel Top Qualité",
        options: {
          topQualityHotel: "Hôtel Top Qualité"
        }
      }
    },
    offer: {
      title: 'Les offres',
      hotel: {
        btn: {
          discover: 'découvrir',
          detail: 'détail des tarifs',
          results: 'liste des hôtels'
        },
        services_equipments: 'Services et équipements'
      },
      rooms: {
        btn: {
          booking: 'Réserver'
        },
        room: 'Chambre',
        breakfast: 'Petit déjeuner',
        availability: 'chambre disponible | chambres disponibles',
        left: 'Plus que'
      },
      fromPrice: 'à partir de',
      bbaNegotiated: 'Tarif BBA',
      bbaNegotiatedTitle: 'Tarif préférentiel BBA',
      travelPolicyExceeded: 'Tarif de l\'hôtel en dehors de la politique voyage',
      greenStayInfo: 'Certifié en tant que "Éco-Hôtel"',
      breakfast: {
        is_included: 'Petit-déjeuner compris',
        is_not_included: 'Petit-déjeuner non compris'
      },
      cancelation: {
        hot_deal: 'Non annulable, non remboursable',
        flex_offer: 'sans frais supplémentaires',
        basic_offer: 'incluant des frais',
        free_cancelation: 'Annulation gratuite {until} {date}',
        non_free_cancelation: 'Annulation payante'
      },
      possible_cancelation_until: 'Annulation possible jusqu\'au',
      error: {
        at_least_one: 'Vous devez choisir au moins une chambre'
      },
      hotdeal_offer: 'offre Hotdeal | offres HotDeal'
    },
    booking: {
      title: 'Ma réservation',
      subtitle: {
        travellers: 'Coodonnées voyageur(s)',
        rooms: 'Répartition des chambres',
        other: 'Autres remarques',
        complement: 'Compléments',
        references: 'Informations complémentaires obligatoires'
      },
      btn: {
        complete_booking: 'finaliser ma réservation'
      },
      info: {
        fromDate: 'Arrivée',
        toDate: 'Départ',
        travellers: 'Voyageurs',
        nbRooms: 'Chambres',
        totalPrice: 'TTC',
        is: 'soit',
        per_night: 'par jour',
        per_room: '@:_perRoom',
        cancel: 'annulation gratuite avent le'
      },
      requests: {
        parking: 'Place de stationnement',
        arrival: 'Arrivée tardive'
      },
      ph: {
        selectTraveller1: 'Sélectionnez un voyageur',
        selectTraveller2: 'Sélectionnez le deuxième voyageur'
      },
      room: 'Chambre ',
      completion: {
        hotel: {
          arrival: 'Arrivée',
          departure: 'Départ',
          rooms: 'Chambre | Chambres',
          single: 'Occupation par 1 personne | Occupation par 1 personne',
          double: 'Occupation par 2 personnes | Occupation par 2 personnes'
        },
        travellers: {
          part: 'Coordonnées voyageur(s)'
        },
        comments: {
          part: 'Remarques',
          carpark: 'Place de stationnement'
        },
        extra: {
          part: 'Commentaires'
        },
        refs: {
          part: 'Informations complémentaires obligatoires'
        }
      },
      summary: {
        room: {
          single: 'Occupation par 1 personne | Occupation par 1 personne',
          double: 'Occupation par 2 personnes | Occupation par 2 personnes'
        }
      }
    },
    confirm: {
      default: {
        title: 'Réservation effectuée',
        phrase: 'Votre réservation a bien été effectuée.'
      },
      validation: {
        title: 'Demande de Validation envoyée',
        phrase: 'Votre demande de réservation a été transmise à un manager de la société pour validation. Dès réponse traitée, vous recevrez une notification.'
      }
    },
    cancel: {
      question: 'Votre réservation ne sera pas validée. Souhaitez-vous poursuivre ?'
    },
    edit: {
      inTime: "Pour modifier votre réservation, vous avez 2 possibilités :<ul><li>l'annuler puis faire une nouvelle réservation</li><li>envoyer un message à votre agent de réservation afin qu'il traite votre demande de modification</li></ul>",
      outdated: "Pour modifier votre réservation, veuillez envoyer un message à votre agent de réservation afin qu'il traite votre demande"
    },
    modify: {
      title: 'Demande de modification de votre réservation'
    },
    offer_reminder: 'Rappel de la demande',
    sortOrder: {
      category: "Par nombre d'étoiles",
      price: 'Par prix par chambre par jour',
      averageRating: 'Par note',
      trainStation: 'Par proximité gare SNCF',
      airport: 'Par proximité aéroport',
      location: "Par proximité point d'intérêt"
    },
    sortShow: {
      negotiated: 'Hôtels à tarifs préférentiels en tête (par défaut)',
      simple: 'Standard'
    },
    hotelAvailabilities: {
      search: {
        title: 'Modifier ma recherche',
        title_or_offline: ' ou faire une demande offline',
        duplicate: {
          title: 'Compléter ma recherche',
          title_or_offline: ' ou faire une demande offline',
          button: 'Compléter ma recherche'
        }
      }
    },
    excludedOffer: {
      excludeNonFree: "L'offre n'est pas annulable gratuitement, vous ne pouvez y accéder.",
      maxPriceExceeded: 'Le prix par chambre dépasse le montant défini, vous ne pouvez accéder à cette offre.',
      unknownBreakfastPrice: 'Ce tarif n’est pas réservable en ligne car le tarif du petit déjeuner, en supplément, n’a pas été indiqué par l’hôtel, vous pouvez faire votre demande à votre agent de réservation.',
      unknown: 'Ce tarif est désactivé pour une raison inconnue. Veuillez contacter votre agent BBA pour plus de précisions.'
    },
    confirmError: {
      title: 'Echec de la réservation',
      text: "La réservation n'a pas pu aboutir. Que souhaitez-vous faire ?",
      giveUp: 'Abandonner',
      offline: 'Demande Offline',
      restart: 'Recommencer'
    },
    travelPolicy: {
      doesntFit: 'Ce tarif est supérieur à la politique voyage définie pour cette destination',
      doesntFitWithoutBreakfast: 'Ce tarif est supérieur à la politique voyage sans petit-déjeuner définie pour cette destination',
      mode: {
        0: '',
        10: '',
        20: 'Si vous le séléctionnez, il sera soumise à validation.',
        30: 'Vous ne pouvez pas y accéder.'
      }
    }
  }
}
